import { useLayoutEffect, useRef } from "react";

const VELOCIDADE_PX_S = 30;
const PAUSA_TOPO_MS = 4000;
const PAUSA_FIM_MS = 4000;

/**
 * Rolagem lenta em ciclo para TV. A posição fica num acumulador fracionado:
 * em telas com escala 100% o navegador arredonda `scrollTop`, então somar
 * ~0,5px por quadro sobre o valor lido nunca sairia do lugar.
 */
export function useTvAutoScroll(fingerprint: string) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    let pos = 0;
    let ultimoTs = performance.now();
    let pausadoAte = ultimoTs + PAUSA_TOPO_MS;
    let rafId = 0;
    el.scrollTop = 0;

    const passo = (agora: number) => {
      const max = el.scrollHeight - el.clientHeight;
      const dt = Math.min(agora - ultimoTs, 100);
      ultimoTs = agora;

      if (max <= 1) {
        pos = 0;
        el.scrollTop = 0;
      } else if (agora >= pausadoAte) {
        if (Math.abs(el.scrollTop - pos) > 2) pos = el.scrollTop;
        if (pos >= max) {
          pos = 0;
          pausadoAte = agora + PAUSA_TOPO_MS;
        } else {
          pos = Math.min(max, pos + VELOCIDADE_PX_S * (dt / 1000));
          if (pos >= max) pausadoAte = agora + PAUSA_FIM_MS;
        }
        el.scrollTop = Math.round(pos);
      }
      rafId = window.requestAnimationFrame(passo);
    };

    rafId = window.requestAnimationFrame(passo);
    return () => window.cancelAnimationFrame(rafId);
  }, [fingerprint]);

  return ref;
}
